import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HeadlinesView.vue'


const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ArticlesView.vue')
  },
  {
    path: '/news/:query',
    name: 'articles',
   
    component: () => import(/* webpackChunkName: "about" */ '../components/ArticlesComp.vue')
  },


]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
